import React, { useMemo } from "react"
import { useTranslation } from "react-i18next"

import { useActiveAnchor } from "shared/lib/useActiveAnchor"
import { QuickNav } from "shared/ui/quick-nav/QuickNav"

import { useProductPageNavigationAnchors } from "../model/useProductPageNavigationAnchors"

function ProductPageNavigationComponent() {
  const { t } = useTranslation()
  const anchors = useProductPageNavigationAnchors()
  const hrefs = useMemo(() => anchors.map(a => a.href), [anchors])
  const activeHref = useActiveAnchor(hrefs)

  return (
    <div className="product-page__nav">
      <QuickNav.Root
        className="product-page__nav-content"
        label={t("Product.Navigation")}
        activeHref={activeHref ?? undefined}
      >
        {anchors.map(anchor => (
          <QuickNav.Anchor key={anchor.key} href={anchor.href}>
            {anchor.label}
          </QuickNav.Anchor>
        ))}
      </QuickNav.Root>
    </div>
  )
}

export const ProductPageNavigation = React.memo(ProductPageNavigationComponent)
